import React from 'react'

function Brevo_frame() {
  return (
    <>
   <div id="whole-content">
  <div id="main-content">
    <p id="text-content" className="default-style">Please wait...</p>
  </div>
</div>
    </>
  )
}

export default Brevo_frame